export default {
  toggleLoading(state, loading) {
    state.loading = loading;
  },
  setWarehouses(state, warehouses) {
    state.warehouses = warehouses;
  },
  setWarehouse(state, warehouse) {
    state.warehouse = warehouse || {
      address: {},
    };
  },
};



// WEBPACK FOOTER //
// ./src/features/private/settings/pages/warehouses/store/mutations.js